import { inject } from '@angular/core'
import type { CanActivateFn } from '@angular/router'
import { Router } from '@angular/router'
import { AuthService } from './auth.service'

// NOTE: Angular runs the guards in a route's canActivate array CONCURRENTLY (via
// combineLatest in prioritizedGuardValue), not sequentially. roleGuard therefore
// cannot rely on authGuard populating the signal first and must rehydrate itself;
// AuthService.fetchMe() dedupes the in-flight request so both still hit /me once.
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService)
  const router = inject(Router)
  const user = auth.currentUser() ?? (await auth.fetchMe())
  if (user) return true
  // FR-050 AC-6.7: a session that ended in-app returns to the brand's login.
  // FR-052 V9-1 (AC-7.2): on an agency host it carries the requested page as returnUrl.
  void router.navigateByUrl(auth.loginUrlFor(state?.url))
  return false
}
